import React, { Component } from 'react';

import SEO, { breadcrumbSchema } from '../common/SEO';
import Header from '../common/Header';
import Footer from '../common/Footer';

import PrivacyText from './privacy/PrivacyText';
import Preloader from '../../hocs/Preloader';

const PRIVACY_JSON_LD = breadcrumbSchema([
  { name: "Home", path: "/" },
  { name: "Privacy Policy", path: "/privacy" },
]);

class Privacy extends Component {
  render() {
    return (
      <div id="page-container" className="full-height">
        <SEO
          title="Privacy Policy"
          description="Privacy policy for fernandedios.com, the personal site of Fernan de Dios."
          path="/privacy"
          jsonLd={PRIVACY_JSON_LD}
        />
        <Header id="privacy-banner" title="Privacy Policy" sub="A commitment to confidentiality." />
        <PrivacyText />
        <Footer />
      </div>
    );
  }
}

export default Preloader(Privacy);
